import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { formListOfProjectSelector, fieldListOfProjectSelector } from '@/state/selector/formSelector' ;
import { panelSettingAtom } from '@/state/atom/panelAtom';
import { projectInuseDetailAtom, projectListInCorporationAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { IconButton, MenuItem, Popover, TextField, Button, Dialog, DialogContent, DialogActions, ListSubheader } from '@material-ui/core';
import { DragDropContext, Draggable, Droppable } from '@react-forked/dnd';
import { API, I18n } from 'aws-amplify';
import { useState, useEffect } from 'react';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
    confirmSubmitListForm,
    getInitDataFilterFormLevel,
    onBeforeDragStartHandler,
    onChangeActiveListForm,
    onChangeFilterFormLevel,
    onChangeFilterFormStatus,
    onChangeFilterFormType,
    onDragEndFormListHandler,
    onSubmitListForm,
    sortActiveFormsByOrder,
    sortListByDictionary
} from './handler/FormListHandler';
import FormListItem from './FormListItem';
import CloseIcon from '@material-ui/icons/Close';
import AddNewFormDev from './AddNewFormDev';
import EditFormDev from './EditFormDev';
import CancelTabsDialog from '../system/dialog/CancelTabsDialog';
import { closeTabId, multiPanelAtom } from '@/state/atom/panelAtom';
import { closePanelTabSelector } from '@/state/selector/panelSelector';
import { useSnackbar } from 'notistack';
import OverFlowTooltipWithTabsMui from '../common/OverFlowTooltipWithTabsMui';
import { getFieldListInCorp } from './handler/FieldListHandler';
import { isDisplaySettingSynonymSearch } from '@/component/formManagement/handler/FormListHandler';
import DataChangePleaseReloadModal from '../common/modal/DataChangePleaseReloadModal';
import { getFormListByCorporation, getFormListGlobalStateAtom } from '@/service/formManagementService';

const renderListFormActive = argsAll => {
    return (
        <DragDropContext
            onDragEnd={result => onDragEndFormListHandler(result, argsAll)}
            onBeforeDragStart={e => onBeforeDragStartHandler(e, argsAll)}
        >
            <Droppable droppableId="droppable">
                {provided => (
                    <ul {...provided.droppableProps} ref={provided.innerRef}>
                        {argsAll?.listFormActive &&
                            argsAll?.listFormActive.map((item, index) => (
                                <Draggable key={item.id} draggableId={`${item.id}`} index={index}
>
                                    {(childProvided, snapshot) => {
                                        if (snapshot.isDragging) {
                                            childProvided.draggableProps.style.left =
                                                'auto!important';
                                        }
                                        return (
                                            <>
                                                <li
                                                    key={index}
                                                    ref={childProvided.innerRef}
                                                    {...childProvided.draggableProps}
                                                    {...childProvided.dragHandleProps}
                                                    // className="listForm-li"
                                                    data-cy="form-item-active"
                                                    className={
                                                        item?.isInuse
                                                            ? 'content-form-list-item'
                                                            : 'content-form-list-item-unuse'
                                                    }
                                                >
                                                    <FormListItem
                                                        key={`form-list-item-${item.id}`}
                                                        item={item}
                                                        argsAll={argsAll}
                                                    />
                                                </li>
                                            </>
                                        );
                                    }}
                                </Draggable>
                            ))}
                        {provided.placeholder}
                    </ul>
                )}
            </Droppable>
        </DragDropContext>
    );
};

const renderListFormInactive = argsAll => {
    return (
        <ul>
            {argsAll?.listFormInactive &&
                argsAll?.listFormInactive.map((item, index) => (
                    <li
                        key={index}
                        className={
                            item?.isInuse
                                ? 'content-form-list-item'
                                : 'content-form-list-item-unuse'
                        }
                    >
                        <FormListItem key={`form-list-item-${item.id}`} item={item} argsAll={argsAll} />
                    </li>
                ))}
        </ul>
    );
};

const DialogConfirmRedirect = props => {
    const onCloseConfirm = (event, reason) => {
        if (event && reason === 'backdropClick') {
            return false;
        }
        props.setIsOpenConfirmRedirect(false);
    };

    const onAcceptRedirect = () => {
        onSubmitListForm(props).then((result) => {
            props.setIsOpenConfirmRedirect(false);

            if(result.isOpenConfirmInactiveForm){
                return;
            }

            switch (props.actionType) {
                case Constant.ACTION_LIST_FORM.ADD_NEW_FORM:
                    props.setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM);
                    break;
                case Constant.ACTION_LIST_FORM.EDIT_FORM:
                case Constant.ACTION_LIST_FORM.DUPLICATE_FORM:
                    props.setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM);
                    break;
                default:
                    break;
            }
        });
    };

    return (
        <Dialog
            open={props.isOpenConfirmRedirect}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    変更を保存しますか?
                    <IconButton
                        className="close"
                        onClick={(event, reason) => onCloseConfirm(event, reason)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={onAcceptRedirect}
                >
                    はい
                </Button>
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={() => props.setIsOpenConfirmRedirect(false)}
                >
                    いいえ
                </Button>
            </DialogActions>
        </Dialog>
    );
};

const DialogConfirmInActiveForm = props => {
    const getMessagePopup = () => {
        // Generate the list items for each form name
        let listFormName = props?.listFormCannotInactive?.map(form => 
            `<li class='form-cannot-inactive'>${Utils.getTextByLanguage(Constant.LANGUAGE_TYPE.JP, form.name)}</li>`
        ).join('');

        // Construct the full message with the <ul> element
        return `
            次のフォーマットはナレッジロボの質問カテゴリ設定に使用されているため、不使用に設定することができません。
            これらの設定変更はスキップします。よろしいですか？
            <ul class='list-form-cannot-inactive'>${listFormName}</ul>
        `;
    }

    const onCloseConfirm = (event, reason) => {
        console.log('event, reason :>> ', event, reason);
        if (event && reason === 'backdropClick') {
            return false;
        };
        props.setIsOpenConfirmInActiveForm(false);
        props.setListFormUpdate([]);
        props.setListFormCannotInactive([]);

        let listFormId = [];

        props?.listFormCannotInactive?.forEach(form => {
            listFormId.push(form.id);
        });

        props?.listFormUpdate?.forEach(form => {
            listFormId.push(form.id);
        });

        onChangeActiveListForm(true,listFormId,props);
        props?.setIsChangeData(false);
    };

    const onAcceptInActiveForm = () => {
        confirmSubmitListForm(props,props.listFormUpdate).then(() => {
            props.setIsOpenConfirmInActiveForm(false);
            props.setListFormUpdate([])
            props.setListFormCannotInactive([]);
            let listFormId = [];

            props?.listFormCannotInactive?.forEach(form => {
                listFormId.push(form.id);
            });

            onChangeActiveListForm(true,listFormId,props);
            props.setIsChangeData(false);

        });
    };

    return (
        <Dialog
            open={props.isOpenConfirmInActiveForm}
            onClose={(event, reason) => onCloseConfirm(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <DialogContent>
                <div className="confirm-dialog-content">
                    <div className='message-confirm-cannot-inactive' dangerouslySetInnerHTML={{ __html: getMessagePopup() }} />
                    <IconButton
                        className="close"
                        onClick={(event, reason) => onCloseConfirm(event, reason)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={onAcceptInActiveForm}
                >
                    はい
                </Button>
                <Button
                    className="confirm-dialog-button"
                    variant="contained"
                    color="primary"
                    onClick={(event,reason) =>  onCloseConfirm(event, reason)}
                >
                    いいえ
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default function FormListDev(props) {
    const [isOpenConfirmRedirect, setIsOpenConfirmRedirect] = useState(false);
    const [isChangeData, setIsChangeData] = useState(false);
    const [actionType, setActionType] = useState(false);

    const [settingSlideRecoilState, setSettingSlideRecoilState] = useRecoilState(panelSettingAtom);
    const [openScreen, setOpenScreen] = useState(Constant.FORM_MANAGEMENT_SCREEN.LIST_FORM);
    const [formEdit, setFormEdit] = useState({});
    const [isDuplicateForm, setIsDuplicateForm] = useState(false);
    const closePanelTab = useSetRecoilState(closePanelTabSelector);
    const [closeTabIdState, setCloseTabIdState] = useRecoilState(
        closeTabId
    );
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [isConfirmCancelTabs, setIsConfirmCancelTabs] = useState(false);

    // common userDetail state
    const userDetail = useRecoilValue(userAtom);
    // common projectInuse state
    const projectInuseDetail = useRecoilValue(projectInuseDetailAtom);
    // common corporationDetail state
    const corporationDetail = useRecoilValue(corporationAtom);
    // common projectList state
    const projectList = useRecoilValue(projectListInCorporationAtom);
    const [listProjectInCorp, setListProjectInCorp] = useState([]);

    //list form in corporation
    const [listForm, setListForm] = useRecoilState(formListOfProjectSelector);

    // common fieldList state
    const [fieldListInState, setFieldListInState] = useRecoilState(fieldListOfProjectSelector);

    //list form in corporation for render
    const [listAllForm, setListAllForm] = useState([]);
    //list corp shared form
    const [listCorpSharedForm, setListCorpSharedForm] = useState([]);
    //list form by filter formType: control order and status form
    const [listFormByType, setListFormByType] = useState([]);
    //list form by filter 3 option
    const [listFormByFilter, setListFormByFilter] = useState([]);
    //list form active: render in screen
    const [listFormActive, setListFormActive] = useState([]);
    //list form inactive: render in screen
    const [listFormInactive, setListFormInactive] = useState([]);
    // args filter form
    const [argsFormFilter, setArgsFormFilter] = useState({
        formType: Constant.FORM_TYPE.FORM_REQ_QA,
        formLevel: 'all',
        formStatus: 'all'
    });

    const [listActiveFormLabel, setListActiveFormLabel] = useState(I18n.get('FIELDFORMLB041'));
    const [listInActiveFormLabel, setListInActiveFormLabel] = useState(I18n.get('FIELDFORMLB009'));
    const [isChangeDataAddNewForm, setIsChangeDataAddNewForm] = useState(false);
    const [isEditDataForm, setIsEditDataForm] = useState(false);

    //state add form type
    const [addFormType, setAddFormType] = useState(Constant.FORM_TYPE.FORM_REQ_QA);
    const [formTypePopover, setFormTypePopover] = useState(null);
    const isOpenFormTypePopover = Boolean(formTypePopover);
    const id = isOpenFormTypePopover ? 'simple-popover' : undefined;
    const { enqueueSnackbar } = useSnackbar();

    const [usedFormButtonExpand, setUsedFormButtonExpand] = useState(true);

    const [isOpenConfirmInActiveForm,setIsOpenConfirmInActiveForm] = useState(false);
    const [listFormUpdate,setListFormUpdate] = useState([]);
    const [listFormCannotInactive,setListFormCannotInactive] = useState([])
    const [isOpenModalReloadPage, setIsOpenModalReloadPage] = useState(false);
    const  [fromListActive, setFromListActive] = useState(0);
    const [fromListInactive, setFromListInactive] = useState(0);

    const onOpenEditForm = (form) => {
        setIsDuplicateForm(false);
        let formClone = {...form};
        if(Utils.isEmptyArray(form.viewPermission)){
            formClone.viewPermission =  []
        }
        if(Utils.isEmptyArray(form.chatPermission)){
            formClone.chatPermission =  []
        }

        // reset permissions when form isSynonym = on and toggle on/off synonym in form = on follow CR 117576
        const isActiveSynonym = isDisplaySettingSynonymSearch(corporationDetail, formClone?.type, projectInuseDetail) && formClone?.isSynonym
        if (isActiveSynonym) {
            formClone.viewPermission = [Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR, Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT];
            formClone.editPermission = [Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.CREATOR_ONLY,Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.PROJECT_MANAGER];
            formClone.createTicketForOwnerPermission = [Constant.KNOWLEDGE_VIEW_EDIT_PERMISSION.IN_PROJECT];
            formClone.additionalCreateTicketForOwnerPermission = [];
            formClone.chatPermission = Constant.KNOWLEDGE_CHAT_PERMISSION.IN_PROJECT
        }
        /** */
        setFormEdit(formClone);
        setActionType(Constant.ACTION_LIST_FORM.EDIT_FORM);
        if(isChangeData){
            setIsOpenConfirmRedirect(true);
        }else{
            setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM);
        }
    };
    
    const argsAll = {
        ...props,
        listAllForm,
        setListAllForm,
        listCorpSharedForm,
        setListCorpSharedForm,
        listProjectInCorp: listProjectInCorp,
        setListProjectInCorp: setListProjectInCorp,
        listFormByType: listFormByType,
        setListFormByType: setListFormByType,

        API: props?.API,
        listForm: listForm,
        setListForm: setListForm,
        setIsLoading: props.setIsLoading,
        projectInuseDetail: projectInuseDetail,
        settingSlideRecoilState: settingSlideRecoilState,
        setSettingSlideRecoilState: setSettingSlideRecoilState,

        listFormByFilter,
        listFormActive,
        listFormInactive,
        setListFormByFilter,
        setListFormActive,
        setListFormInactive,

        argsFormFilter: argsFormFilter,
        setArgsFormFilter: setArgsFormFilter,

        openScreen,
        setOpenScreen,
        formEdit,
        setFormEdit,
        isDuplicateForm,
        setIsDuplicateForm,

        isChangeData,
        setIsChangeData,
        isOpenConfirmRedirect,
        setIsOpenConfirmRedirect,
        actionType,
        setActionType,
        onOpenEditForm,
        isConfirmCancelTabs,
        setIsConfirmCancelTabs,
        panelList,
        setPanelList,
        closePanelTab,
        enqueueSnackbar,
        fieldListInState,
        setFieldListInState,
        isOpenConfirmInActiveForm,
        setIsOpenConfirmInActiveForm,
        setListFormUpdate,
        listFormUpdate,
        listFormCannotInactive,
        setListFormCannotInactive,
        isOpenModalReloadPage, 
        setIsOpenModalReloadPage,
        corporationDetail
    };

    const onClickFormTypeSelected = formType => {
        setActionType(Constant.ACTION_LIST_FORM.ADD_NEW_FORM);
        setAddFormType(formType);
        if (isChangeData) {
            setIsOpenConfirmRedirect(true);
        } else {
            setOpenScreen(Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM);
        }
        setFormTypePopover(null);
    };

    useEffect(() => {
        if (props.tabId === closeTabIdState) {
            if (isChangeData || (isChangeDataAddNewForm && openScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM) || (isEditDataForm && openScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM)) {
                setIsConfirmCancelTabs(true);
            } else {
                let currentPanelInfo = Utils.getPanelInfo(props.panelId, panelList);
                if (!currentPanelInfo || Utils.isEmptyObject(currentPanelInfo)) return;
                closePanelTab({
                    event: null,
                    panelType: currentPanelInfo.type,
                    panelId: props.panelId,
                    tabId: props.tabId
                });
            }
            setCloseTabIdState(0);
        }
    },[closeTabIdState])

    // get list project in corporation to filter list form
    useEffect(() => {
        getInitDataFilterFormLevel(argsAll, projectList);
    }, [projectList]);


    useEffect(() => {
        const amountOfActiveForm = listFormActive?.length ? listFormActive?.length : 0;
        setListActiveFormLabel(`${I18n.get('FIELDFORMLB041')} (${amountOfActiveForm})`);
        if (amountOfActiveForm > 0) {
            setUsedFormButtonExpand(true);
        }
    }, [listFormActive]);

    useEffect(() => {
        const amountOfInActiveForm = listFormInactive?.length ? listFormInactive?.length : 0;
        setListInActiveFormLabel(`${I18n.get('FIELDFORMLB009')} (${amountOfInActiveForm})`);
    }, [listFormInactive]);

    useEffect( () => {
        setListAllForm(listForm);

        let listFormShared = listForm.filter(item => item.affiliationOrganization !== corporationDetail.id)
        listFormShared = listFormShared.map((item, index) => item.affiliationOrganization);
        listFormShared = [...new Set(listFormShared)];

        const listCorpShared = props.allListCorp.filter(item => listFormShared.includes(item.id))
        setListCorpSharedForm(Utils.sortListByNameCorpDictionaryASC(listCorpShared));

        // search form by filter
        onChangeFilterFormType(argsFormFilter.formType, listForm, argsAll);
    }, [
        listForm, 
        corporationDetail.id, 
        corporationDetail?.limitValue?.usingAIAuto, 
        props.allListCorp
    ]);

    const getListFormActive = async (filterObject) => {
        let otherParams = {
            isGetForList: true,
            projectActive: projectInuseDetail.id,
            from: fromListActive,
            size: 10,
            projectId: projectInuseDetail.id
        };

        if(!Utils.isEmptyObject(filterObject)){
            let filterObjectParams = {...filterObject};
            filterObjectParams.isOnAIAuto = Utils.isCorporationOnAIAuto(corporationDetail)
            filterObjectParams.isOnAI = Utils.isCorporationOnAI(corporationDetail);
            filterObjectParams.isOnKnowledge = Utils.isCorporationOnKnowledge(corporationDetail);
            filterObjectParams.isOnEmailTicketMode = Utils.isEnableCreateEmailTicketMode(corporationDetail, projectInuseDetail)
            otherParams = {...otherParams, filterFormList: JSON.stringify(filterObject)}
        }

        const listFormResult = await getFormListByCorporation(API,corporationDetail.id,{...otherParams
        })

        console.log('listForm---------- :>> ', listFormResult);

        let newFrom = fromListActive + listFormResult.length
        setFromListActive(newFrom)
    }

    useEffect(() => {
        let formsActive = listFormByFilter.filter(form => form.isProjectInuse);
        let mailSetting = projectInuseDetail.mailSetting;
        if (mailSetting) {
            mailSetting = Utils.convertJSONDataToObject(mailSetting);
            if (!mailSetting.isEmailResponseSettingFunction) {
                formsActive = formsActive.filter(form => form.type !== Constant.FORM_TYPE.EMAIL_FORMAT);
            }
        }
        formsActive = sortActiveFormsByOrder(formsActive, argsAll);
        setListFormActive(formsActive);

        let formsInactive = listFormByFilter.filter(form => !form.isProjectInuse);
        formsInactive = sortListByDictionary(formsInactive);
        setListFormInactive(formsInactive);

    }, [listFormByFilter, projectInuseDetail]);

    const handleOnclickListForm = id => {
        const addFieldMenuElement = document.getElementById(id);
        const classNameOfElement = addFieldMenuElement.className;
        if (classNameOfElement === 'accordionForm accordionForm--show') {
            document.getElementById(id).classList.remove('accordionForm--show')
        } else if (classNameOfElement === 'accordionForm') {
            document.getElementById(id).classList.add('accordionForm--show');
        }
    };

    const isShowOptionsKnowledge = () => {
        let inviterSetting = Utils.convertJSONDataToObject(corporationDetail?.inviterSetting);
        let isKnowledgeService = corporationDetail.knowledgeService === Constant.STATUS_SERVICE_PERMISSION.ON;
        if ([Constant.CORPORATION_CONTRACT_TYPE.GUEST_DESK].includes(corporationDetail.contractType) && inviterSetting?.usingKnowledgeService === Constant.STATUS_SERVICE_PERMISSION.ON) {
            isKnowledgeService = true;
        };
        return isKnowledgeService;
    }

    const renderListForm = () => {
        return (
            <div className="groupManage">
                <DialogConfirmRedirect {...argsAll} />
                <DialogConfirmInActiveForm {...argsAll} />
                <div className="headManage">
                    <div className="headManage-top headManage-top--sp">
                        <h2 className="headManage-title">{I18n.get('FIELDFORMTT002')}</h2>
                        <div className="headManage-tools">
                            <div className="headManage-item">
                              
                            </div>
                            <div className="keep">
                                <Button
                                    className="btn-primary btn-hg32"
                                    onClick={e => onSubmitListForm(argsAll)}
                                    disabled={!isChangeData}
                                >
                                    {I18n.get('COMBTN011')}
                                </Button>
                            </div>
                            <div className="addManage">
                                <IconButton
                                    className="itemNav"
                                    aria-label="more"
                                    id="long-button"
                                    aria-controls={isOpenFormTypePopover ? 'long-menu' : undefined}
                                    aria-expanded={isOpenFormTypePopover ? 'true' : undefined}
                                    aria-haspopup="true"
                                    onClick={e => setFormTypePopover(e.currentTarget)}
                                >
                                    <img src="/assets/image/icon-add-manage.svg" alt="" />
                                </IconButton>
                                <Popover
                                    className="nav-addManage"
                                    id={isOpenFormTypePopover ? 'simple-popover' : undefined}
                                    open={isOpenFormTypePopover}
                                    anchorEl={formTypePopover}
                                    onClose={() => setFormTypePopover(null)}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left'
                                    }}
                                >
                                    <ul>
                                        <li
                                            className="active"
                                            onClick={e => {
                                                onClickFormTypeSelected(
                                                    Constant.FORM_TYPE.FORM_REQ_QA
                                                );
                                            }}
                                        >
                                            <span className="item">
                                                <img
                                                    src="/assets/image/icon-add-plus-manage.svg"
                                                    alt=""
                                                />
                                            </span>
                                            <span className="text">
                                                {I18n.get('FIELDFORMBTN007')}
                                            </span>
                                        </li>
                                        <li
                                            onClick={e =>
                                                onClickFormTypeSelected(
                                                    Constant.FORM_TYPE.FORM_REQ_NOTICE
                                                )
                                            }
                                        >
                                            <span className="item">
                                                <img
                                                    src="/assets/image/icon-add-plus-manage.svg"
                                                    alt=""
                                                />
                                            </span>
                                            <span className="text">{I18n.get('お知らせ')}</span>
                                        </li>
                                        {isShowOptionsKnowledge() && (
                                            <li
                                                onClick={e =>
                                                    onClickFormTypeSelected(
                                                        Constant.FORM_TYPE.FORM_KNOWLEDGE
                                                    )
                                                }
                                            >
                                                <span className="item">
                                                    <img
                                                        src="/assets/image/icon-add-plus-manage.svg"
                                                        alt=""
                                                    />
                                                </span>
                                                <span className="text">
                                                    {I18n.get('FIELDFORMBTN010')}
                                                </span>
                                            </li>
                                        )}
                                        <li
                                            onClick={e =>
                                                onClickFormTypeSelected(
                                                    Constant.FORM_TYPE.FORM_TASK
                                                )
                                            }
                                        >
                                            <span className="item">
                                                <img
                                                    src="/assets/image/icon-add-plus-manage.svg"
                                                    alt=""
                                                />
                                            </span>
                                            <span className="text">
                                                {I18n.get('FIELDFORMBTN009')}
                                            </span>
                                        </li>
                                    </ul>
                                </Popover>
                            </div>
                        </div>
                    </div>

                    <div className="formSearch formSearch--col3">
                        <div className="formSearch-info">
                            <label className="formSearch-label">
                                {I18n.get('FIELDFORMBTN023')}
                            </label>
                            <div className="formSearch-control">
                                <TextField
                                    className="form-control--wrap form-control--hg32"
                                    select
                                    variant="outlined"
                                    value={argsFormFilter.formType}
                                    onChange={event =>
                                        onChangeFilterFormType(
                                            event.target.value,
                                            listAllForm,
                                            argsAll
                                        )
                                    }
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                >
                                    <MenuItem
                                        value={Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_QA}
                                        data-cy="form-filter-type-req-qa"
                                    >
                                        {I18n.get('FIELDFORMBTN007')}
                                    </MenuItem>
                                    <MenuItem
                                        value={Constant.FILTER_LIST_FORM_TYPE.FORM_REQ_NOTICE}
                                        data-cy="form-filter-type-req-notice"
                                    >
                                        {I18n.get('FIELDFORMBTN008')}
                                    </MenuItem>
                                    {isShowOptionsKnowledge() && (
                                        <MenuItem
                                            value={Constant.FILTER_LIST_FORM_TYPE.FORM_KNOWLEDGE}
                                        >
                                            {I18n.get('FIELDFORMBTN010')}
                                        </MenuItem>
                                    )}
                                    <MenuItem value={Constant.FILTER_LIST_FORM_TYPE.FORM_TASK}>
                                        {I18n.get('FIELDFORMBTN009')}
                                    </MenuItem>
                                    <MenuItem value={Constant.FILTER_LIST_FORM_TYPE.FORM_SYSTEM}>
                                        {I18n.get('FIELDFORMBTN012')}
                                    </MenuItem>
                                </TextField>
                            </div>
                        </div>
                        <div className="formSearch-info">
                            <label className="formSearch-label">{I18n.get('FIELDFORMLB007')}</label>
                            <div className="formSearch-control">
                                <TextField
                                    className="form-control--wrap form-control--hg32"
                                    value={argsFormFilter.formLevel}
                                    select
                                    variant="outlined"
                                    onChange={event =>
                                        onChangeFilterFormLevel(event.target.value, argsAll)
                                    }
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                >
                                    <MenuItem value="all">{I18n.get('DRILLB010')}</MenuItem>
                                    <MenuItem value={Constant.FORM_DEFINITION.SYSTEM}>
                                        {I18n.get('FIELDFORMBTN017')}
                                    </MenuItem>
                                    <MenuItem value={Constant.FORM_DEFINITION.SAMPLE}>
                                        SysAdmin
                                    </MenuItem>
                                    <ListSubheader
                                        className="fontw-bold select-item"
                                        color="inherit"
                                        disableSticky
                                        onClickCapture={e => e.stopPropagation()}
                                    >
                                        {I18n.get('FIELDFORMLB044')}
                                    </ListSubheader>
                                    {listProjectInCorp &&
                                        listProjectInCorp.map(item => {
                                            if (
                                                item.type !== Constant.PROJECT_TYPE.BASE &&
                                                item.type !== Constant.PROJECT_TYPE.CUSTOMER
                                            ) {
                                                return (
                                                    <MenuItem key={item.id} value={item.id}>
                                                        <OverFlowTooltipWithTabsMui
                                                            value={Utils.getTextByLanguage(
                                                                Constant.LANGUAGE_TYPE.JP,
                                                                item.name
                                                            )}
                                                        />
                                                    </MenuItem>
                                                );
                                            }
                                        })}
                                    <ListSubheader
                                        className="fontw-bold select-item"
                                        color="inherit"
                                        disableSticky
                                        onClickCapture={e => e.stopPropagation()}
                                    >
                                        {I18n.get('FIELDFORMLB045')}
                                    </ListSubheader>
                                    {listCorpSharedForm.length &&
                                        listCorpSharedForm.map(item => (
                                            <MenuItem key={item.id} value={item.id}>
                                                <OverFlowTooltipWithTabsMui value={item.title} />
                                            </MenuItem>
                                        ))}
                                </TextField>
                            </div>
                        </div>
                        <div className="formSearch-info">
                            <label className="formSearch-label">{I18n.get('FIELDFORMLB008')}</label>
                            <div className="formSearch-control">
                                <TextField
                                    className="form-control--wrap form-control--hg32"
                                    select
                                    variant="outlined"
                                    value={argsFormFilter.formStatus}
                                    onChange={event =>
                                        onChangeFilterFormStatus(event.target.value, argsAll)
                                    }
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: 'bottom',
                                                horizontal: 'left'
                                            },
                                            getContentAnchorEl: null,
                                            className: 'selectDrop'
                                        }
                                    }}
                                >
                                    <MenuItem value="all">{I18n.get('DRILLB010')}</MenuItem>
                                    <MenuItem value="use">{I18n.get('FIELDFORMBTN015')}</MenuItem>
                                    <MenuItem value="unuse">{I18n.get('FIELDFORMBTN016')}</MenuItem>
                                </TextField>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="contentManage">
                    <div
                        className={
                            usedFormButtonExpand
                                ? 'accordionForm accordionForm--show'
                                : 'accordionForm'
                        }
                        id="list-form-active"
                    >
                        <div
                            className="accordionHead"
                            onClick={e => {
                                handleOnclickListForm('list-form-active');
                            }}
                        >
                            <span className="accordionHead-item">
                                <img src="/assets/image/icon-pin.svg" alt="" />
                            </span>
                            <span className="accordionHead-text">{listActiveFormLabel}</span>
                        </div>
                        <div
                            className="accordionContent"
                            // onScroll={e => {
                            //     console.log('onScroll :>> ', 1);
                            //     let isOnBottom =
                            //         e.currentTarget.scrollHeight - e.currentTarget.scrollTop ===
                            //         e.currentTarget.clientHeight;
                            //     if (isOnBottom) {
                            //         getListFormActive(argsAll.argsFormFilter)
                            //     }
                            // }}
                        >
                            <div
                                className={
                                    [
                                        Constant.FORM_TYPE.FORM_KNOWLEDGE,
                                        Constant.FORM_TYPE.FORM_MASTER
                                    ].includes(argsFormFilter.formType)
                                        ? 'knowledgeFormListManage'
                                        : 'listManage'
                                }
                            >
                                {renderListFormActive(argsAll)}
                            </div>
                        </div>
                    </div>
                    <div className="accordionForm" id="list-form-inactive">
                        <div
                            className="accordionHead"
                            onClick={e => {
                                handleOnclickListForm('list-form-inactive');
                            }}
                        >
                            <span className="accordionHead-item">
                                <img src="/assets/image/icon-pin-outline.svg" alt="" />
                            </span>
                            <span className="accordionHead-text">{listInActiveFormLabel}</span>
                        </div>
                        <div className="accordionContent">
                            <div
                                className={
                                    [
                                        Constant.FORM_TYPE.FORM_KNOWLEDGE,
                                        Constant.FORM_TYPE.FORM_MASTER
                                    ].includes(argsFormFilter.formType)
                                        ? 'knowledgeFormListManage listManage-inactive'
                                        : 'listManage listManage-inactive'
                                }
                            >
                                {renderListFormInactive(argsAll)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const callbackAddNewForm = (isCancel) => {
        setIsChangeDataAddNewForm(isCancel);
    }

    const callbackEditForm = isCancel => {
        setIsEditDataForm(isCancel)
    }

    return (
        <div className="formList-body">
            {/* <LoadingIndicator isLoading={isLoading} /> */}

            {openScreen === Constant.FORM_MANAGEMENT_SCREEN.LIST_FORM && renderListForm()}
            {openScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM && (
                <AddNewFormDev
                    API={props?.API}
                    openScreen={openScreen}
                    setOpenScreen={setOpenScreen}
                    listForm={listForm}
                    setListForm={setListForm}
                    addFormType={addFormType}
                    listFormActive={listFormActive}
                    parentCallback={callbackAddNewForm}
                    {...props}
                />
            )}
            {openScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM && (
                <EditFormDev
                    API={props?.API}
                    formEdit={formEdit}
                    openScreen={openScreen}
                    setOpenScreen={setOpenScreen}
                    listForm={listForm}
                    setListForm={setListForm}
                    isDuplicateForm={isDuplicateForm}
                    setIsDuplicateForm={setIsDuplicateForm}
                    parentCallback={callbackEditForm}
                    {...props}
                />
            )}
            <CancelTabsDialog argsAll={argsAll} />
            <DataChangePleaseReloadModal
                isOpen={isOpenModalReloadPage}
                setIsOpen={setIsOpenModalReloadPage}
            />
        </div>
    );
}
